<div class="item">
  <div class="info">
    <div class="title">
      <div class="left">
        <div class="quantity" [class.not-decimal]="item.qty < 10">{{ item.item.tip ? 1 : item.qty }}</div>
        <div class="name">{{ item.item.name }}</div>
      </div>
      <div class="price">{{ item.value | currency }}</div>
    </div>
    
    <div class="options">
      <span *ngFor="let option of item.item.options">{{option.qty}}x {{option.name}}</span>
    </div>
    <div class="additional-info" *ngIf="item.item.additionalInfo">
      Obs: {{ item.item.additionalInfo }}
    </div>
  </div>
</div>